function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#5a7a7d;stroke-linecap:round;stroke-linejoin:round;stroke-width:50px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M714,484.17l12.33,7.94a59.23,59.23,0,0,1,17.57,81.64L624.63,758.39A59.19,59.19,0,0,1,543,776l-12.31-8a59.19,59.19,0,0,1-17.55-81.64L632.42,501.71A59.19,59.19,0,0,1,714,484.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M171.43,560.6,85,189a67.74,67.74,0,0,1,48.39-82.31l13.77-3.56a67.71,67.71,0,0,1,82.3,48.39l93.82,339.35"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M481.17,521.6,495.09,98.42A67.73,67.73,0,0,0,432.61,26.2l-14.16-1a67.72,67.72,0,0,0-72.24,62.47l-22.9,403.26"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M632.39,501.71l80.29-274a62.37,62.37,0,0,0-44-76.19l-12.62-3.4a62.38,62.38,0,0,0-76.2,43.94L481.19,521.62"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M383.15,951.82C370.79,829,206.66,774.41,206.66,774.41l-13.58-57.08,77.69-53.91c30.47-24.75,34.28-66.47,13.94-102.81-15.89-28.43-48.88-17-48.88-17S90.35,579.33,58.9,600C-8.6,644.4,41,813.63,68.35,865.42S173,1076.58,173,1076.58l18.89,83.56"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "749.77 561.86 732.76 848.13 628.51 1076.6"
})));

function SvgLeft3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 778.32 1185.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft3);
export default __webpack_public_path__ + "static/media/left-3.7a9f5662.svg";
export { ForwardRef as ReactComponent };